import { render, staticRenderFns } from "./_course_image_upload.vue?vue&type=template&id=5638e7d8"
import script from "./_course_image_upload.vue?vue&type=script&lang=js"
export * from "./_course_image_upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports